<template>
    <div class="archive-results" :class="{'details-opened': selectedItem !== null, 'mobile-is-scrolling': scrolled}"
         :style="{
                paddingTop: isMobileWidth ? (160 + ((activeFilters ? Math.ceil(activeFilters.length / 3) : 0) + (searchTerm ? 1 : 0)) * 22) + 'px' : null
                }"
    >
        <div class="row">
            <div class="col-lg-10">
                <header class="header top-header row" :class="{'is-scrolling': scrolled}" :style="{
                height: isMobileWidth ? (160 + ((activeFilters ? Math.ceil(activeFilters.length / 3) : 0) + (searchTerm ? 1 : 0)) * 22) + 'px' : null
                }">
                    <div class="logo col-lg-3">
                        <a class="off-scroll" href="https://fashionheritage.eu" id="logo">European Fashion Heritage
                            Association</a>
                        <a class="on-scroll" href="https://fashionheritage.eu" id="logo-small">European Fashion Heritage
                            Association</a>
                    </div>
                    <div class="col-lg-6 center active-filters">
                        <div v-if="activeFilters.length > 0 || (searchTerm && searchTerm.length > 0)"
                             class="active-filters-list d-none d-lg-block ">
                            <span
                                    v-for="filter in activeFilters"
                                    :key="filter.term"
                                    @click="removeFilter(filter.type, filter.term)"
                                    :title="filter.term"
                            ><span>{{filter.term}}</span></span><span
                                class="filter-text-item"
                                v-if="searchTerm"
                                @click="setSearchTerm(null, null)"
                        >{{searchTerm}}</span>
                            <button
                                    class="reset-filters"
                                    @click="removeAllFilters()"
                            >Reset
                            </button>
                        </div>
                        <h2 v-if="((activeFilters.length < 1) || isMobileWidth) && window.width >= 992">Explore archive</h2>
                        <p v-if="!(activeFilters.length > 0 || (searchTerm && searchTerm.length > 0)) || window.width < 992"
                           class="intro">
                            Explore 1 million historical dresses, catwalk photographs, accessories,
                            drawings, sketches, videos and fashion catalogies from more than 40 fashion institutions
                            across Europe</p>
                    </div>
                    <div class="col-lg-4 d-none d-lg-block search">
                        <form
                                @submit.prevent="setSearchTerm()"
                        >
                            <div class="search-wrapper">
                                <input id="search" v-model="search" placeholder="Search the archive"/>
                            </div>
                        </form>
                    </div>
                </header>

                <div class="col-lg-3" id="accordion-filter">
                    <h3>Filter <br class="d-none d-lg-inline"/>the Collection <span
                            class="d-inline-block d-lg-none float-right"
                            @click="mobileToggleFilters()"
                    >
                        <svg width="24" height="24" v-if=!filtersAccordion>
                            <g>
                                <line x1="12" y1="0" x2="12" y2="24" stroke="#fff"/>
                                <line x1="0" y1="12" x2="24" y2="12" stroke="#fff"/>
                            </g>
                        </svg>
                    </span></h3>
                    <div class="counter" :class="{'counter-active': activeFilters.length}">{{totalItems ? totalItems :
                        0}}
                        objects found
                    </div>

                    <div class="d-block d-lg-none center active-filters">
                        <div v-if="activeFilters.length > 0 || (searchTerm && searchTerm.length > 0)"
                             class="active-filters-list">
                            <span
                                    v-for="filter in activeFilters"
                                    :key="filter.term"
                                    @click="removeFilter(filter.type, filter.term)"
                                    :title="filter.term"
                            >{{filter.term}}</span><span
                                class="filter-text-item"
                                v-if="searchTerm"
                                @click="setSearchTerm(null, null)"
                        >{{searchTerm}}</span>
                            <button
                                    class="reset-filters"
                                    @click="removeAllFilters()"
                            >Reset
                            </button>
                        </div>
                    </div>

                    <FashionFiltersWrapper
                            :filters=filters
                            :callback=setFilter
                            :keys=filterKeys
                            :filtersStatus=filtersStatus
                            :activeFilters=activeFilters
                            :filterLabels=filterLabels
                            :accordion=filtersAccordion
                            :accordionFn=mobileToggleFilters
                            :searchModel=search
                            :searchFn=setSearchTerm
                            :searchTerm=searchTerm
                    />
                </div>

                <masonry
                        :cols="2"
                        :gutter="0"
                        v-if="window.width <= 992"
                        class="results masonry mobile-masonry"
                        ref="results-masonry"
                >
                    <ArchiveItem
                            v-for="item in items"
                            :item="item"
                            :key="item.id"
                            :callback=selectItem
                            @imageLoaded="imageLoaded"
                    />
                </masonry>

                <transition-group
                        name="fade"
                        tag="div"
                        class="results masonry"
                        id="results"
                        v-if="window.width > 992"
                        ref="resultsContainer"
                        mode="out-in"
                >
                    <ArchiveItem
                            v-for="item in items"
                            :item="item"
                            :key="item.id"
                            :callback=selectItem
                            :ref="'item-' + item.id"
                            :id="'item-' + item.id"
                            :current="selectedItem"
                            @imageLoaded="imageLoaded"
                    />
                </transition-group>
                <div
                        class="bottom-observer"
                        ref="bottomObserver"
                        v-observe-visibility="{callback: resultsInteserction, throttle: 300}"
                >
                    <font-awesome-icon icon="spinner" v-if="isFetching" spin/>
                </div>
            </div>
        </div>

        <DetailsView
                :item="selectedItem"
                :close=closeDetails
                v-if="selectedItem !== null"
                :callback=selectItem
                :key="selectedItem"
                id="details-view-element"
                ref="detailsViewElement"
        />

    </div>
</template>

<script>
import axios from 'axios'
import FashionFilter from './FashionFilter'
import ArchiveItem from './ArchiveItem'
import FashionFiltersWrapper from './FashionFiltersWrapper'
import DetailsView from './DetailsView'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import router from '../router'
import {isElementInViewport} from '../helpers/media'
import VueScrollTo from 'vue-scrollto'
import {EventBus} from './event-bus'
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock'

library.add(faSpinner)

export default {
  name: 'ArchiveView',
  data () {
    return {
      items: [],
      selectedItem: null,
      scrolled: false,
      detailsReference: null,
      filterKeys: [
        'objectType',
        'dataProviders',
        // 'Designers',
        'techsAndMaterials',
        'colour',
        'dcCreator',
        'datesNormalized'
      ],
      filterLabels: {
        'objectType': 'Object',
        'dataProviders': 'Provider',
        // 'Designers': 'Designers',
        'techsAndMaterials': 'Material',
        'colour': 'Colour',
        'dcCreator': 'Creator',
        'datesNormalized': 'Date'
      },
      filters: {
        objectType: null,
        dataProviders: null,
        techsAndMaterials: null,
        colour: null,
        dcCreator: null,
        datesNormalized: null
        // Designers: null
      },
      filtersStatus: {
        objectType: false,
        dataProviders: false,
        techsAndMaterials: false,
        colour: false,
        dcCreator: false,
        datesNormalized: false
        // Designers: false
      },
      activeFilters: [],
      search: '',
      searchTerm: null,
      totalItems: 0,
      countItems: 0,
      itemsCounter: 25,
      itemsLoadedCounter: 0,
      isFetching: false,
      isMobileWidth: false,
      filtersAccordion: false,
      window: {
        width: 0,
        height: 0
      }
    }
  },
  components: {
    FashionFiltersWrapper,
    FashionFilter,
    ArchiveItem,
    DetailsView,
    FontAwesomeIcon
  },
  created () {
    let vm = this
    window.addEventListener('resize', vm.handleResize)
    vm.handleResize()
    vm.detailsReference = this.$refs.detailsViewElement
  },
  destroyed () {
    let vm = this
    window.removeEventListener('resize', vm.handleResize)
  },
  computed: {
    queryFilters: (state) => {
      let obj = {}
      state.activeFilters.map(e => {
        obj[e.type] = e.term
        return true
      })

      return obj
    }
  },
  beforeMount () {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    handleResize () {
      let vm = this
      vm.window.width = window.innerWidth
      vm.window.height = window.innerHeight
      vm.isMobileWidth = window.innerWidth < 992
    },
    mobileToggleFilters (value) {
      let vm = this
      if (value === false) {
        vm.filtersAccordion = false
      } else {
        vm.filtersAccordion = !vm.filtersAccordion
      }
    },
    handleScroll () {
      this.scrolled = window.scrollY > 10
    },
    closeDetails () {
      let vm = this
      const current = vm.selectedItem
      vm.selectedItem = null
      router.push({path: `/browse`})
      setTimeout(() => {
        VueScrollTo.scrollTo('#item-' + current, 400, {offset: -150})
      }, 1000)
      EventBus.$emit('details-closed')
      vm.toggleBodyClass('removeClass', 'details-opened')
      clearAllBodyScrollLocks()
    },
    selectItem (item) {
      let vm = this
      vm.selectedItem = item.id || item
      router.push({path: `/browse/record/${vm.selectedItem}`})
      VueScrollTo.scrollTo('#item-' + vm.selectedItem, 400, {offset: -150})
      // EventBus.$emit('details-opened')
      // vm.toggleBodyClass('addClass', 'details-opened')
      if (vm.window.width < 992) {
        setTimeout(() => {
          const element = document.getElementById('details-view')
          disableBodyScroll(element)
        }, 100)
      }
    },
    resultsInteserction (isVisible, entry) {
      let vm = this

      if (!vm.isFetching) {
        vm.itemsCounter += 10
        vm.fetchItems()
      }
    },
    computeHeight () {
      const bricks = document.getElementsByClassName('masonry-brick')
      const grid = document.getElementById('results')
      let heighs = [0, 0]
      let cnt = 0;

      [].forEach.call(bricks, function (el) {
        heighs[cnt++ % 2] += el.offsetHeight
      })

      grid.style.height = Math.max.apply(Math, heighs) + 'px'
    },
    removeFilter (filter, term) {
      let vm = this
      vm.activeFilters = vm.activeFilters.filter(f => f.type !== filter)
      vm.items = []
      vm.$router.replace({
        query: vm.queryFilters
      })

      vm.fetchItems()
    },
    removeAllFilters (event) {
      if (event) {
        event.preventDefault()
      }
      let vm = this
      vm.activeFilters = []
      vm.searchTerm = null
      vm.search = null
      vm.items = []
      router.push({path: `/browse`})
      vm.fetchItems()
    },
    setFilter (filter, term, uri) {
      let vm = this
      let filters = vm.activeFilters
      let filterTerm = term.toString()

      // vm.searchTerm = null // @TODO check if combo search
      vm.search = null
      vm.itemsCounter = 25
      vm.itemsLoadedCounter = 0
      vm.items = []

      if (!filters.find(e => e.type === filter)) {
        filters.push({
          type: filter,
          term: filterTerm,
          value: uri && uri !== '' ? uri : filterTerm
        })
        vm.activeFilters = filters
        vm.fetchItems()
      } else if (filters.find(e => (e.type === filter && e.term !== term))) {
        filters = filters.filter(e => (e.type !== filter))
        filters.push({
          type: filter,
          term: filterTerm,
          value: uri && uri !== '' ? uri : filterTerm
        })
        vm.activeFilters = filters
        vm.fetchItems()
      }
    },
    setSearchTerm (event, data) {
      if (event) {
        event.preventDefault()
      }
      let vm = this

      if (vm.search) {
        vm.searchTerm = vm.search
        vm.search = null
      } else {
        vm.searchTerm = null
        vm.search = null
      }

      vm.fetchItems()
    },
    imageLoaded (status) {
      let vm = this
      vm.itemsLoadedCounter++
    },
    fetchItems (id = null, isLoadingMore = false) {
      let vm = this

      if (!vm.isFetching) {
        if (vm.countItems >= vm.totalItems && vm.totalItems !== 0) {
          vm.isFetching = false
        }

        this.$router.replace({
          query: vm.queryFilters
        })
        vm.isFetching = true

        axios.post(
          'https://portal.fashionheritage.eu/api/search/',
          {
            term: vm.searchTerm || 'fashion',
            count: vm.itemsCounter,
            filters: vm.activeFilters,
            browse: vm.activeFilters && vm.activeFilters.length > 0 ? undefined : true
          })
          .then(result => {
            const data = result.data
            vm.items = data.results
            vm.totalItems = data.total
            vm.filters = {
              objectType: data.facets && data.facets.objectType ? sortFilters(data.facets.objectType) : null,
              dataProviders: data.facets && data.facets.dataProviders ? sortFilters(data.facets.dataProviders) : null,
              techsAndMaterials: data.facets && data.facets.techsAndMaterials ? sortFilters(data.facets.techsAndMaterials) : null,
              colour: data.facets && data.facets.colour ? sortFilters(data.facets.colour) : null,
              dcCreator: data.facets && data.facets.dcCreator ? sortFilters(data.facets.dcCreator) : null,
              datesNormalized: data.facets && data.facets.datesNormalized ? sortFilters(data.facets.datesNormalized) : null
              // Designers: data.facets && data.facets.Designers ? sortFilters(data.facets.Designers) : null
            }
            vm.countItems = data.count
            vm.isFetching = false

            if (id) {
              vm.selectedItem = id
              vm.toggleBodyClass('addClass', 'details-opened')
            }

            if (
              isElementInViewport(this.$refs.bottomObserver) &&
              vm.countItems < vm.totalItems && vm.totalItems !== 0 &&
              !vm.isFetching
            ) {
              vm.itemsCounter += 25
              vm.fetchItems(id, true)
            } else if (
              vm.selectedItem &&
              !isLoadingMore &&
              vm.itemsLoadedCounter === vm.itemsCounter - 25
            ) {
              setTimeout(() => {
                VueScrollTo.scrollTo('#item-' + vm.selectedItem, 400, {offset: -150})
              }, 3000)
            }
          })
          .catch(err => {
            console.error('err: ', err)
            setTimeout(function () {
              vm.isFetching = false
            }, 1000)
          })
      }
    }
  },
  mounted () {
    let vm = this
    vm.fetchItems(this.$route.params.id)

    window.addEventListener('keypress', function (e) {
      const charCode = e.keyCode

      if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode === 8) {
        EventBus.$emit('letterKeypress', String.fromCharCode(e.keyCode))
      }
    })
  }
}

const sortFilters = (filter) => {
  if (filter) {
    filter.terms = filter.terms.sort((a, b) => {
      var nameA = a.term.toUpperCase()
      var nameB = b.term.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
    })
  }

  return filter
}

</script>

<style lang="scss">
    @import "_ArchiveView.scss";
</style>



// WEBPACK FOOTER //
// src/components/ArchiveView.vue